VLW.slider = class extends VLW.classBase {
	static s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
	}
	static guid() {
		return VLW.slider.s4() + '-' + VLW.slider.s4();
	}
	static uniqueId(){
		let uid;
		while(!uid){
			let _uid = VLW.slider.guid();
			if(!VLW.slider.instances[_uid]){
				uid = _uid;
			}
		}
		return uid;
	}
	static get instances(){
		if(!VLW.slider._instances){
			VLW.slider._instances = {};
		}
		return VLW.slider._instances;
	}
	static registerInstance(instance, el){
		let uid = VLW.slider.uniqueId();
		VLW.slider.instances[uid] = instance;
		el.setAttribute('data-vlwslider-uid', uid);
	}
	static create(el, ctrl){
		let uid = el.getAttribute('data-vlwslider-uid');
		if(uid && VLW.slider.instances[uid]){
			return VLW.slider.instances[uid];
		} else {
			return new VLW.slider(el, ctrl);
		}
	}
	constructor(el, ctrl) {
		super();
		this.elt             = el;
		VLW.slider.registerInstance(this, el);
		this.isRendering     = true;
		this.elt.vlwInstance = this;
		this.ctrl            = ctrl;
		this.ul              = this.elt.querySelector("._slider");
		this.li              = this.elt.querySelectorAll("._slider li");
		this._currentPosition = 0;
		this.max             = this.li.length;
		this.directionNav    = this.elt.hasAttribute("data-slider-directionNav");
		this.slideshow       = this.ctrl.slideshow 		| false;
		this.slideshowSpeed = 5500;
		this.mode            = this.ctrl.mode 			|| "slide";
		this.transitionTime  = this.ctrl.mode === 'slide' ? 1 : 0.3; // slide ou fade
		if(this.ctrl.transitionTime){
            this.transitionTime = this.ctrl.transitionTime;
		}
        if(this.ctrl.slideshowSpeed){
            this.slideshowSpeed = this.ctrl.slideshowSpeed;
        }
		if(ctrl.onEnterFrameAddOn){
			this.onEnterFrameAddOn = this.ctrl.onEnterFrameAddOn;
		}
		this.dragCurs        = Draggable.create(this.elt.querySelector("._slider"), {
			type           : "x",
			throwResistance: 16000000,
			dragResistance : 0.6,
			dragClickables : true,
			throwProps     : true,
			maxDuration    : 1,
			minDuration    : 1,
			snap           : this.snapDraggable
		})[0];
		this.ul.classList.add("mode_" + this.mode);
		this.create_Elt();
		this.goTo(0, true);
		this.onEnterFrame();
		this.cpt = 0;
		window.addEventListener("resize",this.onResize);
		this.elt.classList.toggle("_oneElement",this.max===1);
		this.autoSlide();
	}
	onResize(){
		TweenMax.set(this.ul, {x: (-this.ul.offsetWidth * (this.currentPosition))});
		this.dragCurs.update();
	}

	snapDraggable(end) {
		let _position = -(this.dragCurs.deltaX > 0 ? Math.ceil(end / this.ul.offsetWidth) : Math.floor(end / this.ul.offsetWidth));
		this.currentPosition=_position;
		return -_position * this.ul.offsetWidth;
	}

	onEnterFrame() {
		if(this.isRendering) {
            let curTransformCursor = (CONFIG.IE11 === false) ?
                new WebKitCSSMatrix(window.getComputedStyle(this.ul).webkitTransform) :
                new MSCSSMatrix(window.getComputedStyle(this.ul).transform);
			let _x                 = (curTransformCursor.m41);
			if (_x >= this.ul.offsetWidth) {
				TweenMax.set(this.ul, {x: (-this.ul.offsetWidth * (this.max - 1))});
				this.dragCurs.update();
			}
			if (_x <= -this.ul.offsetWidth * (this.max)) {
				TweenMax.set(this.ul, {x: 0});
				this.dragCurs.update();
			}
			if(this.onEnterFrameAddOn && typeof this.onEnterFrameAddOn === 'function'){
                this.onEnterFrameAddOn(this);
			}
			requestAnimationFrame(this.onEnterFrame);
		}
	}

	create_Elt() {
		this.li.forEach((li, i) => {
		    li.style.transform = "translate3D(" + (i * 100) + "%,0,0)";
		    li.setAttribute("slider-index", i);
        });
		this.createControlNav();
		this.createArrow();
		this.createClone();
	}

	createClone() {
		let first             = this.li[0].cloneNode(true);
		let last              = this.li[this.li.length - 1].cloneNode(true);
		last.style.transform  = "translate3D(-100%,0,0)";
		first.style.transform = "translate3D(" + (this.max * 100) + "%,0,0)";
		this.ul.appendChild(first);
		this.ul.insertBefore(last, this.li[0]);
	}

	createControlNav() {
		let ul       = document.createElement('ul');
		let createLi = (e, i) => {
			let li = document.createElement("li");
			li.addEventListener("click", this.clickControlNav);
			ul.appendChild(li);
		};
		ul.className = "_controlNav";
		this.li.forEach(createLi);
		this.elt.appendChild(ul);
		this.controlNav__li = this.elt.querySelectorAll("._controlNav li");
	}

	createArrow() {
		let createEltArrow = (className, callbackClick) => {
			let elt          = document.createElement('div');
			let svg          = document.createElement('div');
			let circle       = document.createElement('div');
			svg.className    = "svg";
			circle.className = "circle";
			elt.appendChild(svg);
			elt.appendChild(circle);
			elt.classList.add(className);
			elt.addEventListener("click", callbackClick);
			return elt;
		};
		this.arrowLeft     = createEltArrow("__leftArrow", this.prev);
		this.arrowRight    = createEltArrow("__rightArrow", this.next);
		this.elt.appendChild(this.arrowLeft);
		this.elt.appendChild(this.arrowRight);
	}

	clickControlNav(e) {
		clearInterval(this.timer);
		this.goTo([...e.currentTarget.parentNode.children].indexOf(e.currentTarget) );
	}

	autoSlide() {
		if (this.slideshow && this.li.length > 1) {
			this.timer = setInterval(this.next, this.slideshowSpeed);
		}
	}

	isTouching(sens) {
		this.goTo(this.currentPosition + sens);
		clearInterval(this.timer);
	}

	next() {
		TweenMax.isTweening(this.ul) === false && this.goTo(this.currentPosition + 1);
	}

	prev() {
		TweenMax.isTweening(this.ul) === false && this.goTo(this.currentPosition - 1);
	}

	goTo(pos, instant = false) {
		switch (this.mode) {
			case "slide":
				TweenMax.to(this.ul, this.transitionTime, {x: -pos * this.ul.offsetWidth, ease: Power1.easeInOut});
				this.li[pos] && TweenMax.fromTo((this.li[pos].querySelector("._contentAnim") || {}), (instant) ? 0 : 1, {x: (pos >= this.currentPosition) ? 100 : -100}, {x: 0, delay: .5});
				break;
			case "fade" :
				for (let i = 0, j = this.li.length; i < j; i++) {
					TweenMax.to(this.li[i], this.transitionTime, ((i === pos) ? {autoAlpha: 1, zIndex: 2, delay: .5} : {autoAlpha: 0, zIndex: 1}));
				}
				break;
		}

		this.currentPosition = pos;


	}
	set currentPosition(value){
		this._currentPosition = (value >= this.max) ? 0 : value;
		this._currentPosition = (this._currentPosition<0) ?this.max-1  : this._currentPosition;
		this.updateNavigation();

	}
	get currentPosition(){
		return this._currentPosition;
	}

	updateNavigation(){
	    [...this.ul.querySelectorAll('li')].forEach((li, i) => {
            let index = li.getAttribute('slider-index');
            if(index == this.currentPosition){
                li.classList.add('slider-active');
            } else {
                li.classList.remove('slider-active');
            }
        });
		this.controlNav__li.forEach((elt, i) => elt.classList.remove('selected'));
		this.controlNav__li[this.currentPosition ].classList.add('selected');
	}

	instanceClean() {
		this.isRendering = false;
		clearInterval(this.timer);
		window.removeEventListener("resize",this.onResize);
		this.controlNav__li.forEach((elt) => elt.removeEventListener("click", this.clickControlNav));
		(this.arrowLeft && this.arrowLeft.removeEventListener("click", this.prev));
		(this.arrowRight && this.arrowRight.removeEventListener("click", this.left));
		super.instanceClean();
	}
};
